import axios from "@/libs/api.request";
// 获取列表
export const getCod = data => {
  if (typeof data['no_type'] === 'undefined' || !data['no_type']) {
    data['no_type'] = 'airway_number';
  }
  return axios.request({
    url: "/finance/cod/order",
    method: "post",
    data
  });
};

export const getSearchConfig = () => {
  return axios.request({
    url: "/finance/cod/order/searchConfig",
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/cod/checkBill/createClientCheckBill",
    method: "post",
    data
  });
};

export const cancelHangStatus = data => {
  return axios.request({
    url: "/finance/cod/order/cancelHangStatus",
    method: "post",
    data
  });
};

export const hang = data => {
  return axios.request({
    url: "/finance/cod/order/batchException",
    method: "post",
    data
  });
};

export const submitRemarks = data => {
  return axios.request({
    url: "/finance/cod/order/batchRemarks",
    method: "post",
    data
  });
};

export const addResCod = data => {
  return axios.request({
    url: "/finance/cod/checkBill/createAgentCheckBill",
    method: "post",
    data
  });
};

// 生成银行手续费账单
export const createBankFeeBill = data => {
  return axios.request({
    url: "/finance/CodBankBill/create",
    method: "post",
    data
  });
};

// 获取COD币种
export const getCodCurrency = params => {
  return axios.request({
    url: "/finance/CodBankBill/currency",
    method: "get",
    params
  });
};


export const sync = params => {
  return axios.request({
    url: "/finance/cod/order/sync",
    method: "get",
    params
  });
};

export const changeAgent = data => {
  return axios.request({
    url: "/finance/cod/order/changeAgent",
    method: "post",
    data
  });
};
